import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {Button, CardBody, Input, Row, Alert, InputGroupAddon, InputGroup, FormGroup, Label} from "reactstrap";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {Colxx} from "../../../../components/common/CustomBootstrap";

class AddCustomerModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            provinces: this.props.provinces,
            cities: [],
            MeliCode: null,
            fullName: null,
          
            selectedProvince: null,
            selectedCity: null,
            PostalCode: null,
            address: null,
            telephone: null,
            mobile: null,
           
        }
    }

    //componentWillReceiveProps(nextProps) {
    //    if (this.props !== nextProps) {
    //        this.setState({provinces: this.props.provinces});
    //    }
    //}
    componentDidMount() {
        // this.CheckMemberTypeIsAdmin();
        this.loadProvinces();
    }
    InquiryMeliCode = () => {
        let MeliCode = toEnglishNumbers(this.state.MeliCode);

        this.props.showSpinner();
        axios.get('/api/v1/Customer/InquiryMeliCode?melicode=' + MeliCode)
            .then((res) => {
                this.props.hideSpinner();
                let response = res.data.data.data;
                if (response !== null && response.isSuccessful) {
                    if (response.lastName !== null) {
                        this.setState({fullName: response.name + ' ' + response.lastName});
                    } else {
                        this.setState({fullName: response.name});
                    }
                } else {
                    this.setState({fullName: ''});
                    this.props.showAlert('کد ملی معتبر نمی‌باشد', 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    InquiryPostalCode = (postalCode) => {
        this.props.showSpinner();
        axios.get('/api/v1/Customer/InquiryPostalCode?postalcode=' + toEnglishNumbers(postalCode))
            .then((res) => {
                this.props.hideSpinner();
                let response = res.data.data.data;
                if (response.isSuccessful) {
                    this.setState({
                        address: response.fullAddress,
                        editAddress: response.fullAddress
                    });
                } else {
                    this.setState({fullName: ''});
                    this.props.showAlert('کد پستی معتبر نمی‌باشد', 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    loadProvinces = () => {
        axios.get('/api/v1/Province/GetAll')
            .then((res) => {
                this.setState({ provinces: res.data.data });
            })
            .catch((error) => {
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    loadCities = () => {
        this.setState({cities: []});
        let provinceId = this.state.selectedProvince !== null ? this.state.selectedProvince.provinceId : null;

        axios.get('/api/v1/City/GetCityByProvinceId?provinceId=' + provinceId)
            .then((res) => {
                this.setState({cities: res.data.data});
            })
            .catch((error) => {
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    resetForAdd = () => {
        this.setState({
            MeliCode: null,
            fullName: null,
            
            selectedProvince: null,
            selectedCity: null,
            PostalCode: null,
            address: null,
            telephone: null,
            mobile: null,
            
        });
    };

    validate = () => {
        let error = [];
        if (this.state.MeliCode === null || this.state.MeliCode === "") {
            error.push('وارد كردن كد ملی الزامي میباشد!');
        }
        if (this.state.fullName === null || this.state.fullName.length===0) { 
            error.push('وارد كردن نام مشتری الزامی میباشد');
        }
        if (this.state.selectedCity === null ) {
            error.push('انتخاب شهر الزامي میباشد');
        }
        if (this.state.address === null || this.state.address === "") {
            error.push('وارد كردن آدرس الزامی میباشد');
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.addNewCustomer();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    addNewCustomer = () => {
        let request = {
            FullName: toEnglishNumbers(this.state.fullName),
            MeliCode: toEnglishNumbers(this.state.MeliCode),
            Address: toEnglishNumbers(this.state.address),
            Telephone: toEnglishNumbers(this.state.telephone),
            Mobile: toEnglishNumbers(this.state.mobile),
            PostalCode: toEnglishNumbers(this.state.PostalCode),
            CityId: this.state.selectedCity.cityId,
            
        };
 
        this.props.showSpinner();
        axios.post('/api/v1/Customer/AddCustomer', request)
            .then((res) => {
                console.log(res);
                this.props.hideSpinner();
                this.props.closeModal("addCustomerModal");
                this.props.showAlert(res.data.data.message, 'success');
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value },
            () => {
                if (name === "selectedProvince") {
                    if (value !== undefined && value !== null) {
                        this.setState({
                            selectedCity: null
                        }, () => this.loadCities());
                    }
                    else {
                        this.setState({
                            selectedCity: null, cities: []
                        })
                    }
                }

            });
    };
    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                        <div className="d-flex flex-md-row flex-column flex-wrap">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label className="d-flex">*شماره حقیقی/حقوقی</Label>
                                <InputGroup className="mb-3">
                                    <Input value={this.state.MeliCode} maxLength={11}
                                        onChange={(e) => this.setState({ MeliCode: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    <InputGroupAddon addonType="append" onClick={() => this.InquiryMeliCode()}>
                                                <span className="input-group-text">
                                                    <i className="fa fa-search" aria-hidden="true"/>
                                                </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                               
                                <Label>*نام کامل مشتری</Label>
                                <Input value={this.state.fullName} maxLength={500}
                                    onChange={(e) => this.setState({ fullName: e.target.value })} />
                            </FormGroup>

                           

                            <FormGroup className="w-md-25 w-100 px-1" >
                                <Label>*استان</Label>
                                <Autocomplete
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="selectedProvince"
                                    value={this.state.selectedProvince}
                                    options={this.state.provinces}
                                    groupBy={(option) => option.provinceName}
                                    getOptionLabel={(option) => option.provinceName}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedProvince")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1" >
                                <Label>*شهر</Label>
                                <Autocomplete
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="selectedCity"
                                    value={this.state.selectedCity}
                                    options={this.state.cities}
                                    groupBy={(option) => option.cityName}
                                    getOptionLabel={(option) => option.cityName}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedCity")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label className="d-flex">کد پستی</Label>
                                <InputGroup className="mb-3">
                                    <Input value={this.state.PostalCode} maxLength={11}
                                           onChange={(e) => this.setState({PostalCode: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    <InputGroupAddon addonType="append" onClick={() => this.InquiryPostalCode(this.state.PostalCode)}>
                                                <span className="input-group-text">
                                                    <i className="fa fa-search" aria-hidden="true"/>
                                                </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>*آدرس</Label>
                                <Input value={this.state.address} type="textarea" maxLength={500}
                                       onChange={(e) => this.setState({address: e.target.value})}/>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>تلفن</Label>
                                <Input value={this.state.telephone} maxLength={11}
                                       onChange={(e) => this.setState({telephone: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>موبایل</Label>
                                <Input value={this.state.mobile} maxLength={11}
                                       onChange={(e) => this.setState({mobile: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                           
                        </div>

                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2" onClick={this.validate}>
                                    ذخیره
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AddCustomerModal;